import { Field } from 'Util/Query';

export class BlogPosts {
    getQuery(option) {
        const query = new Field('blogPosts')
            .addArgument('pageSize', 'Int', option?.pageSize || 9)
            .addArgument('sortFiled', 'String', "post_id")
            .addArgument('sort', '[String]', option?.sort || "ASC")
            .addArgument('filter', 'BlogPostsFilterInput', option?.filter)
            .addFieldList(this._getBlogPosts(option?.isForCustomer));

        return query;
    }

    _getBlogPosts(isForCustomer = false) {
        return [
            'total_count',
            this._getPostsItems(isForCustomer)
        ];
    }

    _getPostsItems(isForCustomer) {
        return new Field('items')
            .addFieldList(this._getItems(isForCustomer));
    }

    _getItems(isForCustomer) {
        const fields = [
            'title',
            'short_content',
            'featured_image',
            'post_id',
            'publish_time',
            'short_filtered_content',
        ];

        if (isForCustomer) {
            fields.push(
                'featured_video',
                'content',
                'content_heading',
                'first_image',
                'identifier',
                'include_in_recent',
                'is_active',
                'media_gallery',
            )
        }

        return fields;
    }

    getPost(post_id) {
        const query = new Field('blogPosts')
            .addArgument('filter', 'BlogPostsFilterInput', { post_id: { eq: post_id } })
            .addFieldList(this._getBlogPost());

        return query;
    }

    _getBlogPost() {
        return [
            this._getPostItem()
        ];
    }

    _getPostItem() {
        return new Field('items')
            .addFieldList(this._getItem());
    }

    _getItem() {
        return [
            'title',
            'short_content',
            'featured_image',
            'featured_list_image',
            'filtered_content',
            'post_id',
            'publish_time',
            this._getPostsCategory()
        ];
    }

    _getPostsCategory() {
        return new Field('categories')
            .addFieldList(this._getCategories());
    }

    _getCategories() {
        return [
            'content',
            'content_heading',
            'title',
            'category_id',
            'posts_count',
            'identifier',
            'is_active',
        ];
    }
}

export default new BlogPosts();
